import React from 'react'
import styles from "./Loader.module.scss"
import { UseSelector, useSelector } from 'react-redux/es/hooks/useSelector'
export const Loader = () => {
    const { live_data } = useSelector((state) => state.stock)
    return (

        live_data ? <div className={styles.body_live}>
            <div class={styles.loader}></div>
        </div> :
            <div className={styles.body}>
                <div class={styles.loader}></div>
            </div>
    )
}
